import {useState} from "react";
import {useDispatch} from "react-redux";
import {NavLink} from "react-router-dom";

import Gravatar from "../../../assets/images/pngs/gravatar.png";
import TokenHelper from "../../../utils/helpers/tokenHelper";
import {ProgressBar} from "react-bootstrap";
import {ThemeMode} from "../../../utils/helpers/constants";
import OrganisationSwitcher from "../../organisationSwitcher/OrganisationSwitcher";
import {removeLoggedInUser} from "../../../store/actions/auth.action";
import {
  toggleMobileDropdownNav,
  toggleNav,
  toggleNavToIcons,
  toggleThemeState
} from "../../../store/actions/component.action";


const HeaderNav = ({component, profile, onboardingStatus}) => {

  const dispatch = useDispatch();
  const [profileDropdown, setProfileDropdown] = useState(false);

  const toggleNavBar = () => dispatch(toggleNav(!component.sideNavMode));
  const toggleTheme = () => dispatch(toggleThemeState(component.themeMode));
  const toggleNavBarOnMobile = () => dispatch(toggleNavToIcons(!component.iconNavMode));
  const toggleMobileDropdown = () => dispatch(toggleMobileDropdownNav(!component.mobileDropdownMode));
  const toggleProfileDropdown = () => setProfileDropdown(!profileDropdown);

  const logoutUser = event => {
    event.preventDefault();
    dispatch(removeLoggedInUser());
  };

  return (
    <div className="main-header side-header sticky sticky-pin" style={{marginBottom: "-64px"}}>
      <div className="container-fluid">
        <div className="main-header-left d-none d-md-block pointer-event">
          <div onClick={toggleNavBarOnMobile} className="main-header-menu-icon" id="mainSidebarToggle"><span/></div>
        </div>
        <div className="main-header-left d-md-none pointer-event">
          <div onClick={toggleNavBar} className="main-header-menu-icon" id="mainSidebarToggle"><span/></div>
        </div>

        {/*{(TokenHelper.getOnboardingStatus() === 'ONBOARDED' && TokenHelper.getUserType() === UserType.TENANT) &&*/}
        {/*  <div className="main-header-center">*/}
        {/*    <GlobalSearchInput/>*/}
        {/*  </div>*/}
        {/*}*/}

        <div className="main-header-right">
          {TokenHelper.getOnboardingStatus() === 'NON_ORGANISATION' ||
          component.appLoader ? "" : <OrganisationSwitcher organisations={profile.userData.organisations}/>
          }

          <div className="main-header-notification">
            <span className="nav-link icon" onClick={toggleTheme}>
              {component.themeMode === ThemeMode.DARK_MODE ?
                <i className="zmdi zmdi-sun header-icons"/> : <i className="zmdi zmdi-brightness-4 header-icons"/>
              }
            </span>
          </div>

          <div className={`dropdown main-profile-menu ${profileDropdown ? "show" : ""}`}
               onClick={toggleProfileDropdown}>
            <div className="d-flex pointer-event">
              <span className="main-img-user">
                <img alt="avatar" src={profile.userData.picture ? profile.userData.picture : Gravatar}/></span>
            </div>
            <div className="dropdown-menu">
              <div className="header-navheading border-bottom">
                <h6 className="main-notification-title">
                  {profile.userData.first_name} {profile.userData.last_name}
                </h6>
                <p>{profile.userData.email}</p>
                {onboardingStatus['completion'] !== 100 &&
                  <div className="mt-4 px-2 text-center">
                    <span className="main-notification-text">Onboarding Progress:
                      <span className="tx-bold ms-2">{onboardingStatus['completion']}%</span>
                    </span>
                    <ProgressBar variant="success" animated now={onboardingStatus['completion']}/>
                  </div>
                }
              </div>


              {TokenHelper.getOnboardingStatus() === "ONBOARDED" &&
                <NavLink className="dropdown-item border-top" to="/iam/profile">
                  <i className="zmdi zmdi-account me-2"></i> My Profile
                </NavLink>
              }
              <a className="dropdown-item" href="mailto:support@mytruq.com?cc=contact@mytruq.com&bcc=info@mytruq.com"
                 target="_blank" rel="noreferrer">
                <i className="zmdi zmdi-email me-2"></i> Support
              </a>
              <NavLink onClick={logoutUser} className="dropdown-item" to="/log-out">
                <i className="fa fa-power-off text-danger"/> Sign Out
              </NavLink>
            </div>
          </div>

          <button className="navbar-toggler navresponsive-toggler collapsed" type="button" data-bs-toggle="collapse"
                  data-bs-target="#navbarSupportedContent-4" aria-controls="navbarSupportedContent-4"
                  aria-expanded="false" aria-label="Toggle navigation" onClick={toggleMobileDropdown}>
            <i className="zmdi zmdi-more-vert header-icons navbar-toggler-icon"/>
          </button>

        </div>
      </div>
    </div>
  );
}

export default HeaderNav;
